import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { RouterProvider } from '@tanstack/react-router';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import 'mantine-react-table/styles.css';
import '@mantine/dropzone/styles.css';
import '@uploadthing/react/styles.css';

import useVersionCheck from './hooks/use-version-check';
import { router } from './router';
import { trpc, TRPCProvider } from './services/trpc';

import './styles.css';

import { DatesProvider } from '@mantine/dates';

import { theme } from './theme';

const WithProviders: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return (
    <MantineProvider theme={theme} forceColorScheme="light">
      <DatesProvider settings={{ locale: 'fr' }}>
        <Notifications position="top-center" autoClose={6 * 1000} limit={3} />
        <TRPCProvider>
          <ModalsProvider modalProps={{ closeOnClickOutside: false }}>
            {children}
          </ModalsProvider>
        </TRPCProvider>
      </DatesProvider>
    </MantineProvider>
  );
};

const App: React.FC = () => {
  useVersionCheck();

  const { data: user } = trpc.auth.me.useQuery();

  if (user === undefined) {
    return null;
  }

  return (
    <>
      <RouterProvider router={router} context={{ user }} />
    </>
  );
};

const AppWithProviders = () => (
  <WithProviders>
    <App />
  </WithProviders>
);

export default AppWithProviders;
